const TacticNames = 
{
    ClassicArmy: "Classic Army",
    Conquistadors: "Conquistadors",
    DefensiveArmy: "Defensive Army",
    Entrenchments: "Entrenchments",
    FightingBand: "Fighting Band",
    Fortifications: "Fortifications",
    HeavyCavalry: "Heavy Cavalry",
    Hussars: "Hussars",
    Legion: "Legion",
    MechanizedArmy: "Mechanized Army",
    MedievalArmy: "Medieval Army",
    MobileArtillery: "Mobile Artillery",
    ModernArmy: "Modern Army",
    NapoleonicArmy: "Napoleonic Army",
    Phalanx: "Phalanx",
    PositionalArmy: "Positional Army",
    ShockTroops: "Shock Troops",
}

module.exports = TacticNames